import React, { useState, useEffect } from "react";
import { useApiRequest } from "../Components/Login/Hooks/useApiRequest";
import { useLocation, useNavigate } from "react-router-dom";

import Digital_Details from "./component";
import DGC from "./DGC";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../config";
const Digital_Details_Container = () => {

  const { makeApiRequest } = useApiRequest();
  const [loader, setLoader] = useState(false);
  const [digitalorderDetailsData, setDigitalOrderDetailsData] = useState([]);
const [profileData, setProfileData] = useState(null);
  const token = localStorage.getItem("UserJWTAuth");
  const deviceId = localStorage.getItem("uuid");


  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);


  const isClaimed = params.get("claim") === "true";
  const lineitemid = params.get("lineitemid");
  const digitalLineItemClaimId = params.get("digitalLineItemClaimId");

  const [orderId, setOrderId] = useState(digitalLineItemClaimId);
console.log(digitalLineItemClaimId); // E969040105F94F66


useEffect(() => {
    digitalOrder_Details(digitalLineItemClaimId);  
    fetchUserDetails();    
  }, []);
  /* ---------------------------------- */
  /* 🔹 HISTORY DIGITAL ORDER (for claimed items) */
  /* ---------------------------------- */
  const digitalOrder_Details = (digitalLineItemClaimId) => {
 

    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/consumerbe/api/v1/digital/claim/details/${digitalLineItemClaimId}`,
      url: `${API_BASE_URL}/consumerbe/api/v1/digital/claim/details/${digitalLineItemClaimId}`,
      method: "GET",
      headers: {
        accept: "application/json, text/plain, */*",
        "x-device-id": localStorage.getItem("uuid") || "",
      },
      handleSuccess: (res) => {
        console.log("Digital Order Details", res);
        setDigitalOrderDetailsData(res?.data?.data || {});
        
      },
      handleError: (err) => {
      
      },
    });
  };


  const fetchUserDetails = () => {
    if (!token) return;

    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/auth/user/profile/details`,
      url: `${API_BASE_URL}/auth/user/profile/details`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      data: {
        request: { oauthToken: `Bearer ${token}` },
      },
      handleSuccess: handleResponseUserDetails,
      handleError: handleErrorUserDetails,
    });
  };
  const handleResponseUserDetails = (res) => {
//console.log("handleResponseUserDetails",res.data.response)


    const data = res?.data?.response;
    if (data) {
      localStorage.setItem("referCode", data.referCode);
      setProfileData(data);
    }
    setLoader(false);
  };

  const handleErrorUserDetails = (error) => {
    setLoader(false);
    const status = error?.response?.status;

 
  };

  if (loader) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

if(true)
{
    return (
<DGC  digitalorderDetailsData={digitalorderDetailsData} profileData={profileData}/>
    )
}

};

export default Digital_Details_Container;